"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapProviderType = exports.MapLocationType = void 0;
let MapProviderType = exports.MapProviderType = /*#__PURE__*/function (MapProviderType) {
  MapProviderType[MapProviderType["Bing"] = 0] = "Bing";
  MapProviderType[MapProviderType["Yandex"] = 1] = "Yandex";
  MapProviderType[MapProviderType["Google"] = 2] = "Google";
  return MapProviderType;
}({});
let MapLocationType = exports.MapLocationType = /*#__PURE__*/function (MapLocationType) {
  MapLocationType["Current"] = "current location on map initialization";
  MapLocationType["CurrentButton"] = "current location on button click";
  MapLocationType["PickupPoint"] = "pickup point was selected";
  MapLocationType["PrimaryAddress"] = "primary address location on map initialization";
  MapLocationType["Searched"] = "searched location";
  MapLocationType["WhenInitialized"] = "stored location on map initialization";
  return MapLocationType;
}({}); // TODO: Flatten this object
// TODO: Remove after flat selection UI is used in all markets